export default "__VITE_ASSET__DFDNTewP__"